import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ParsedFormattedMessage from '@utils/miscellaneous/react-intl-utlis';


const ValidationErrorMessage = props => {

    const {
        isVisible,
        messageText = false,
        messageTextReplacements,
        errorClasses,
        dataTestId,
    } = props;

    const autoTestId = React.useId().replace(/:/g, '');
    const resolvedTestId = dataTestId ?? `validation-error-message-${autoTestId}`;

    return (
        <div className="grid-row margin-tb-5">
            <span
                className={`tablet:grid-offset-4 ${isVisible ? 'shown' : 'hidden'} error--msg ${errorClasses ? errorClasses.join(' ') : ''}`}
                aria-live='assertive'
                role='alert'
                data-testid={resolvedTestId}
            >
                <em>
                    <FontAwesomeIcon icon="exclamation"/>
                </em>
                <ParsedFormattedMessage id={messageText === false ? 'common.no_text' : messageText} values={messageTextReplacements}/>
            </span>
        </div>
    );
};

export default ValidationErrorMessage;
